import {
  FETCH_AGREEMENTS_BEGIN,
  FETCH_AGREEMENTS_SUCCESS,
  FETCH_AGREEMENTS_FAILURE,
  FETCH_CONFIRM_AGREEMENT_BEGIN,
  FETCH_CONFIRM_AGREEMENT_SUCCESS,
  FETCH_CONFIRM_AGREEMENT_FAILURE,
} from '../actions/agreements';

export const initialState = {
  agreed: [],
  error: null,
  isFetching: false,
  needed: [],
};

const agreements = (state = { ...initialState }, action = {}) => {
  switch (action.type) {
    case FETCH_AGREEMENTS_BEGIN:
    case FETCH_CONFIRM_AGREEMENT_BEGIN:
      return {
        ...state,
        error: null,
        isFetching: true,
      };
    case FETCH_AGREEMENTS_SUCCESS:
    case FETCH_CONFIRM_AGREEMENT_SUCCESS:
      return {
        ...state,
        ...action.payload,
        error: null,
        isFetching: false,
      };
    case FETCH_AGREEMENTS_FAILURE:
    case FETCH_CONFIRM_AGREEMENT_FAILURE:
      return {
        ...state,
        error: action.payload,
        isFetching: false,
      };
    default:
      return state;
  }
};

export default agreements;
